"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Notification extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'notification';
        this._org_id = initParams.org_id;
        this._seen = initParams.seen;
        this._created = initParams.created;
        this._category = initParams.category;
        this._objectType = initParams.object_type;
        this._type = initParams.type;
        this._objectId = initParams.object_id;
        this._metadata = initParams.metadata;
        this._message = initParams.message;
        this._description = initParams.description;
    }
    set org_id(value) {
        console.error('Do not set objects this way');
    }
    setOrg_id(value) {
        return this.dataService.updateNotification(this.id, { org_id: value }, this);
    }
    get org_id() {
        return this._org_id;
    }
    set seen(value) {
        console.error('Do not set objects this way');
    }
    setSeen(value) {
        return this.dataService.updateNotification(this.id, { seen: value }, this);
    }
    get seen() {
        return this._seen;
    }
    set created(value) {
        console.error('Do not set objects this way');
    }
    setCreated(value) {
        return this.dataService.updateNotification(this.id, { created: value }, this);
    }
    get created() {
        return this._created;
    }
    set category(value) {
        console.error('Do not set objects this way');
    }
    setCategory(value) {
        return this.dataService.updateNotification(this.id, { category: value }, this);
    }
    get category() {
        return this._category;
    }
    set objectType(value) {
        console.error('Do not set objects this way');
    }
    setObjectType(value) {
        return this.dataService.updateNotification(this.id, { object_type: value }, this);
    }
    get objectType() {
        return this._objectType;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    setType(value) {
        return this.dataService.updateNotification(this.id, { type: value }, this);
    }
    get type() {
        return this._type;
    }
    set objectId(value) {
        console.error('Do not set objects this way');
    }
    setObjectId(value) {
        return this.dataService.updateNotification(this.id, { object_id: value }, this);
    }
    get objectId() {
        return this._objectId;
    }
    set metadata(value) {
        console.error('Do not set objects this way');
    }
    setMetadata(value) {
        return this.dataService.updateNotification(this.id, { metadata: value }, this);
    }
    get metadata() {
        return this._metadata;
    }
    set message(value) {
        console.error('Do not set objects this way');
    }
    setMessage(value) {
        return this.dataService.updateNotification(this.id, { message: value }, this);
    }
    get message() {
        return this._message;
    }
    set description(value) {
        console.error('Do not set objects this way');
    }
    setDescription(value) {
        return this.dataService.updateNotification(this.id, { description: value }, this);
    }
    get description() {
        return this._description;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateNotification(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = Notification;
//# sourceMappingURL=notification.js.map